// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip_tooltip__1FfEz","tip":"tooltip_tip__3u1yy","tipStart":"tooltip_tipStart__2VR_b"};